import React, { useEffect, useState } from 'react'
import CardMarca from './CardMarca'
import MarcasIJson from '../../json/marcasInicio.json';

function MarcasDestacadas() {
  const [marcasDestacadas, setMarcasDestacadas] = useState([])
  useEffect(() => {
    setMarcasDestacadas(MarcasIJson.Marcas)
  },[])
  return (
    <div className='w-full h-3/12 flex flex-col items-center'>
    <div className='w-11/12 h-1/4 flex items-end p-3 justify-center mt-5'>
      <h2 className='text-3xl font-bold '>Agentes oficiales</h2>
    </div>
    <div className='w-full p-3 flex justify-center items-center'>
      <div className='w-full flex justify-evenly items-center flex-wrap'>
          {
            marcasDestacadas.map(md => {
              return <CardMarca marca={md} /> 
            })
        }     
      
      </div>
    </div>
  </div>
  )
}

export default MarcasDestacadas